/*
 * Copyright (C) 2020-present Borza LLC. All rights reserved.
 */

import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const InStock = () => (
  <p className="sm:text-left text-lg text-center">
  <span className="whitespace-no-wrap">
    <FontAwesomeIcon
      fixedWidth={true}
      icon={faCheckCircle}
    />
    In Stock
  </span>
  <span>{" "}</span>
  <span className="whitespace-no-wrap">
    <FontAwesomeIcon
      fixedWidth={true}
      icon={faCheckCircle}
    />
    Ships Same Day
  </span>
</p>
);

export default InStock;
